/**
 * Client-side role names, in every spelling the data has used.
 *
 * "Client" means a user of a consulting firm's customer company (as opposed to
 * a firm user or a system admin). Several components used to check only
 * 'client' | 'user', which hid the discovery grid from company admins.
 */
export const CLIENT_ROLE_NAMES = [
  'client',
  'user',
  'companyUser',
  'company_user',
  'companyAdmin',
  'company_admin',
  'Project Lead',
  'project_lead',
  'stakeholder',
  'cel',
] as const;

const CLIENT_ROLE_SET = new Set<string>(CLIENT_ROLE_NAMES);

export function isClientRoleName(role: unknown): boolean {
  return typeof role === 'string' && CLIENT_ROLE_SET.has(role);
}
